import React from 'react'

import ActionIcon from 'components/lib/DesignSystem/ActionIcon'
import Tooltip from 'components/lib/DesignSystem/Tooltip'

import { Info } from './DesignSystem/Icons'

function Popup({
  on,
  position,

  ContentComponent,
  TriggerComponent,

  infoIconSize,
  style = {},
}) {
  if (!ContentComponent) return TriggerComponent
  return (
    <Tooltip
      trigger={on || 'hover'}
      placement={position || 'bottomRight'}
      overlayStyle={{ ...style }}
      text={ContentComponent}
    >
      {TriggerComponent || (
        <ActionIcon
          id="Popup_info_icon"
          Icon={Info}
          iconProps={{ width: infoIconSize || '18px', height: infoIconSize || '18px' }}
        />
      )}
    </Tooltip>
  )
}

/**
 * @deprecated use DesignSystem/Tooltip.js instead.
 */
export default Popup
